import { render, staticRenderFns } from "./reborrowCountForSubmit.vue?vue&type=template&id=1dd3df24&scoped=true"
import script from "./reborrowCountForSubmit.vue?vue&type=script&lang=js"
export * from "./reborrowCountForSubmit.vue?vue&type=script&lang=js"
import style0 from "./reborrowCountForSubmit.vue?vue&type=style&index=0&id=1dd3df24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd3df24",
  null
  
)

export default component.exports